module.exports = __webpack_public_path__ + "static/media/3.1c3ad46a.png";